import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { Dialog } from 'teacher-ui-client/components/dialog'
import { eq } from 'ember-truth-helpers'
import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'

interface Signature {
  Element: HTMLDivElement
  Args: {
    show?: boolean
    close?: () => void
    noOutsideClose?: boolean
  }
  Blocks: {
    default: []
  }
}

export const ThemedModal: TOC<Signature> = <template>
  {{#if @show}}
    <Dialog
      class="max-w-3xl min-w-lg overflow-hidden rounded-lg"
      @onClose={{@close}}
      @showBackdrop={{true}}
      @noOutsideClose={{@noOutsideClose}}
    >
      <div ...attributes data-test-modal>
        {{yield}}
      </div>
    </Dialog>
  {{/if}}
</template>

interface ModalHeaderSignature {
  Element: HTMLDivElement
  Args: {
    themeKey?: ThemeKeys
  }
  Blocks: {
    default: []
  }
}

export const ModalHeader: TOC<ModalHeaderSignature> = <template>
  <div
    class="flex items-center p-6
      {{if (eq @themeKey ThemeKeys.blue) 'bg-oceany-blue-150'}}
      {{if (eq @themeKey ThemeKeys.green) 'bg-ms-green-150'}}
      {{if (eq @themeKey ThemeKeys.darkBlue) 'bg-wl-blue-150'}}
      {{if (eq @themeKey ThemeKeys.orange) 'bg-juicy-orange-200'}}
      {{if (eq @themeKey ThemeKeys.black) 'bg-black text-white'}}
      {{if (eq @themeKey ThemeKeys.default) 'bg-white'}}
      {{unless @themeKey 'bg-white'}}"
    ...attributes
    data-test-modal-header
  >
    {{yield}}
  </div>
</template>

interface ModalBodySignature {
  Element: HTMLDivElement
  Blocks: {
    default: []
  }
}

export const ModalBody: TOC<ModalBodySignature> = <template>
  <div class="p-6" ...attributes data-test-modal-body>
    {{yield}}
  </div>
</template>

interface ModalFooterSignature {
  Element: HTMLDivElement
  Blocks: {
    default: []
  }
}

export const ModalFooter: TOC<ModalFooterSignature> = <template>
  <div class="border-dusty-black-50 border-t p-6" ...attributes data-test-modal-footer>
    {{yield}}
  </div>
</template>

interface CloseButtonSignature {
  Args: {
    close: () => void
  }
}

export const CloseButton: TOC<CloseButtonSignature> = <template>
  <button type="button" class="ml-auto" aria-label={{t "close"}} {{on "click" @close}} data-test-modal-close>
    <PhosphorIcon @icon="phosphor-x-bold" class="ml-2 h-8 w-8" />
  </button>
</template>

export default ThemedModal
